
<div
    class="Badge"
    :class="[
        `is-${colorId}`,
        { 'is-small': size === 'small' },
        { 'is-large': size === 'large' },
    ]"
    :style="badgeStyle"
>
    <div class="Badge-Wrapper">
        <span v-if="hasIcon" class="IconBefore">
            <slot name="iconBefore"></slot>
        </span>
        <span class="Label">
            <span v-if="value">{{ value }}</span>
            <slot></slot>
        </span>
    </div>
</div>
